export default "__VITE_ASSET__6HFHKeWH__"